
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 15H20v-3a.5.5 0 00-.5-.5h-7V9H15a1.5 1.5 0 001.5-1.5v-6A1.5 1.5 0 0015 0H9a1.5 1.5 0 00-1.5 1.5v6A1.5 1.5 0 009 9h2.5v2.5h-7a.5.5 0 00-.5.5v3H1.5A1.5 1.5 0 000 16.5v6A1.5 1.5 0 001.5 24h6A1.5 1.5 0 009 22.5v-6A1.5 1.5 0 007.5 15H5v-2.5h14V15h-2.5a1.5 1.5 0 00-1.5 1.5v6a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5v-6a1.5 1.5 0 00-1.5-1.5zM8 16.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5h6a.5.5 0 01.5.5zm.5-9v-6A.5.5 0 019 1h6a.5.5 0 01.5.5v6a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5zm14.5 15a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5h6a.5.5 0 01.5.5z"}})])
          )
        }
      }
    